import axios, {AxiosResponse} from 'axios';

const axiosWithoutDefaults = axios.create();

export function isSsoEnabled(): Promise<boolean> {
    return axiosWithoutDefaults.get('oauth/sso/enabled').then((resp: AxiosResponse<boolean>) => resp.data);
}

export function isLoggedInViaSSO(): Promise<boolean> {
    return axiosWithoutDefaults.get('oauth/sso/check').then((resp: AxiosResponse<boolean>) => resp.data);
}



// WEBPACK FOOTER //
// ./src/apis/SessionBasedLoginAPI.ts